export const iconDefaultProps = {
  color: {
    type: String,
    default: 'currentColor',
  },
  size: {
    type: [String, Number],
    default: '24',
  },
}
